module.exports = __webpack_public_path__ + "static/img/s1.42df98b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new/img/slider/s1.jpg
// module id = 1k9U
// module chunks = 1